// pollingService.js - Simple replacement for WebSocket
class PollingService {
  constructor() {
    this.listeners = new Map();
    this.pollingInterval = null;
    this.lastMessageId = null;
  }

  connect(userId) {
    if (this.pollingInterval) return;
    
    // Load initial messages
    this.fetchMessages();
    
    // Poll every 5 seconds for new messages
    this.pollingInterval = setInterval(() => {
      this.fetchMessages();
    }, 5000);
    
    console.log('Polling service started');
  }

  disconnect() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
    console.log('Polling service stopped');
  }

  async fetchMessages() {
    try {
      const token = localStorage.getItem('access_token');
      const response = await fetch('/api/admin/burner/messages', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      
      if (data.messages && data.messages.length > 0) {
        const newestMessage = data.messages[0];
        
        // If this is a new message, trigger the event
        if (this.lastMessageId !== newestMessage.id) {
          this.lastMessageId = newestMessage.id;
          
          // Notify listeners
          const callbacks = this.listeners.get('new_burner_message') || [];
          callbacks.forEach(callback => callback(newestMessage));
        }
      }
    } catch (error) {
      console.error('Polling error:', error);
    }
  }

  on(event, callback) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, []);
    }
    this.listeners.get(event).push(callback);
  }

  off(event, callback) {
    if (!this.listeners.has(event)) return;
    const callbacks = this.listeners.get(event).filter(cb => cb !== callback);
    if (callbacks.length === 0) {
      this.listeners.delete(event);
    } else {
      this.listeners.set(event, callbacks);
    }
  }

  emit(event, data) {
    // For polling, emit is not used
    console.log('PollingService.emit:', event, data);
  }

  subscribeToBurner() {}
  unsubscribeFromBurner() {}
  onBurnerMessage(callback) {
    this.on('new_burner_message', callback);
  }
}

export const pollingService = new PollingService();